function AdminCustomProfileInlineEditor(props) {
  const draft = props.draft;
  const channelType = props.channelType;
  const lang = props.lang;
  const isSaving = props.isSaving;
  const uploadingChannel = props.uploadingChannel;
  const cropperDialog = props.cropperDialog;
  const resolvedImageUrlCache = props.resolvedImageUrlCache;

  const channelMeta = ADMIN_CUSTOM_PROFILE_META[channelType];
  const channelState = _.get(draft.channels, channelType, {});
  const effectiveState = channelState;
  const counterValue = (effectiveState.display_name || "").length;
  const uploadInputId =
    "admin-custom-profile-upload-" +
    (draft.row_key || draft.profile_id || channelType) +
    "-" +
    channelType;
  const channelError =
    _.get(draft.fieldErrors, channelType) ||
    _.get(channelState, "save_error") ||
    "";
  const hasImage = !!(
    effectiveState.image_path ||
    effectiveState.preview_url ||
    effectiveState.pending_image_data
  );
  const hasConfiguredName = hasRequiredDisplayName(effectiveState);
  const hasConfiguredImage = hasImage;
  const resolvedChannelImageUrl =
    effectiveState.preview_url ||
    effectiveState.initial_preview_url ||
    resolvedImageUrlCache[effectiveState.image_path] ||
    "";
  const hasResolvedImage = !!resolvedChannelImageUrl;
  const imageUrl = hasResolvedImage ? resolvedChannelImageUrl : "";
  const previewName = (effectiveState.display_name || "").trim();
  const previewImage = imageUrl;
  const previewFrom = channelMeta.previewFrom || channelMeta.label;

  const isBusy =
    isSaving || uploadingChannel === channelType || cropperDialog.show;
  const currentMode = draft.mode || "default";
  const modeOptions = [
    {
      value: "default",
      label: lang.__setting_admin_custom_profile_mode_default || "RMP Profile",
    },
    {
      value: "disabled",
      label: lang.__setting_admin_custom_profile_mode_disabled || "LINE OA",
    },
  ];

  const previewPanel = (
    <AdminCustomProfilePreviewPanel
      mode={currentMode}
      lang={lang}
      channelType={channelType}
      avatarUrl={draft.avatar_url}
      displayname={draft.displayname}
      previewFrom={previewFrom}
      previewName={previewName}
      previewImage={previewImage}
      hasConfiguredName={hasConfiguredName}
      hasConfiguredImage={hasConfiguredImage}
    />
  );

  return (
    <div className="acp-inline-editor" key={channelType}>
      <div className="acp-inline-editor-columns">
        {/* Left column: radios + inputs */}
        <div className="acp-inline-left-col">
          <div className="acp-inline-mode-selector">
            {_.map(modeOptions, function (opt) {
              const radioId =
                "acp-mode-" +
                (draft.row_key || draft.profile_id) +
                "-" +
                opt.value;
              return (
                <label
                  key={opt.value}
                  className={
                    "acp-mode-radio-label" +
                    (currentMode === opt.value ? " -active" : "")
                  }
                >
                  <input
                    type="radio"
                    name={"acp-mode-" + (draft.row_key || draft.profile_id)}
                    id={radioId}
                    value={opt.value}
                    checked={currentMode === opt.value}
                    onChange={function () {
                      props.onModeChange(opt.value);
                    }}
                    disabled={isBusy}
                  />
                  <span>{opt.label}</span>
                </label>
              );
            })}
          </div>
          {currentMode === "custom" ? (
            <div className="acp-inline-input-side">
              <div className="acp-inline-upload-block">
                <button
                  type="button"
                  className={
                    "admin-custom-profile-avatar-trigger -sm" +
                    (!hasResolvedImage ? " -empty" : "")
                  }
                  onClick={function () {
                    document.getElementById(uploadInputId).click();
                  }}
                  disabled={isBusy}
                >
                  {!hasResolvedImage ? (
                    <span className="admin-custom-profile-upload-placeholder">
                      {hasConfiguredImage ? (
                        <i className="icon icon-circle-notch animate-spin"></i>
                      ) : (
                        <i className="icon icon-plus"></i>
                      )}
                      <span>
                        {hasConfiguredImage
                          ? lang.__loading || "Loading..."
                          : lang.__setting_admin_custom_profile_upload_placeholder}
                      </span>
                    </span>
                  ) : (
                    <img className="admin-custom-profile-image -sm" src={imageUrl} />
                  )}
                </button>
                <input
                  id={uploadInputId}
                  className="admin-custom-profile-file-input"
                  type="file"
                  accept=".png,.jpg,.jpeg,image/png,image/jpeg"
                  onChange={function (e) {
                    props.onImageSelect(channelType, e);
                  }}
                  disabled={isBusy}
                />
                {hasConfiguredImage ? (
                  <button
                    type="button"
                    className="sp-btn -link admin-custom-profile-inline-action -remove"
                    onClick={function () {
                      props.onClearChannelImage(channelType);
                    }}
                    disabled={!hasImage || isBusy}
                    title={lang.__setting_admin_custom_profile_remove_image}
                  >
                    <i className="icon icon-trash"></i>
                  </button>
                ) : null}
              </div>

              <div className="acp-inline-name-block">
                <div className="acp-inline-name-label">
                  <label className="sp-label">
                    {lang.__setting_admin_custom_profile_display_name}
                  </label>
                  <span className="acp-inline-name-counter">{counterValue}/20</span>
                </div>
                <div className="acp-inline-name-input-wrap">
                  <input
                    className="sp-input acp-inline-name-input"
                    maxLength={20}
                    value={effectiveState.display_name}
                    onChange={function (e) {
                      props.onUpdateChannelValue(
                        channelType,
                        "display_name",
                        e.target.value,
                      );
                    }}
                    disabled={isBusy}
                  />
                </div>
                {channelError ? (
                  <div className="admin-custom-profile-error-text">{channelError}</div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>

        {/* Right column: preview always present */}
        <div className="acp-inline-preview-side">
          {previewPanel ? (
            <React.Fragment>
              <div className="admin-custom-profile-preview-title">
                {lang.__setting_admin_custom_profile_preview || "ตัวอย่าง"}
              </div>
              {previewPanel}
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </div>
  );
}
